import { render, staticRenderFns } from "./ZonesIpv4.vue?vue&type=template&id=0a44d18a&scoped=true&"
import script from "./ZonesIpv4.vue?vue&type=script&lang=js&"
export * from "./ZonesIpv4.vue?vue&type=script&lang=js&"
import style0 from "./ZonesIpv4.vue?vue&type=style&index=0&id=0a44d18a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44d18a",
  null
  
)

export default component.exports